import {
  AppPublicLayout,
  AppPublicPage,
  PublicDocument,
} from "./../layout";

export function Nutzungsbedingungen() {
  return (
    <AppPublicLayout>
      <AppPublicPage width="narrow">
        <PublicDocument>
          <h1>Nutzungsbedingungen für Nutzer von Logami</h1>

          <p className="lead">
            Version 1.0
          </p>

          <h2>1. Geltungsbereich</h2>
          <p>
            Diese Nutzungsbedingungen gelten für Personen, die durch ein
            Unternehmen zur Nutzung von Logami eingeladen wurden.
          </p>
          <p>
            Logami ist eine Software zur Planung, Durchführung und Dokumentation
            von Aufträgen.
          </p>
          <p>
            Mit der erstmaligen Anmeldung akzeptiert der Nutzer diese
            Nutzungsbedingungen.
          </p>

          <h2>2. Verhältnis zum Unternehmen</h2>
          <p>
            Der Zugang zu Logami wird durch das jeweilige Unternehmen
            bereitgestellt.
          </p>
          <p>
            Das Unternehmen ist für die Verwaltung von Benutzerkonten, Rollen
            und Berechtigungen verantwortlich.
          </p>
          <p>Der Nutzer verwendet Logami im Auftrag seines Unternehmens.</p>
          <p>
            Der Zugang kann durch das Unternehmen jederzeit geändert oder
            entzogen werden.
          </p>

          <h2>3. Benutzerkonto</h2>
          <p>Jeder Nutzer erhält ein persönliches Benutzerkonto.</p>
          <p>
            Zugangsdaten sind vertraulich zu behandeln und dürfen nicht an
            Dritte weitergegeben werden.
          </p>
          <p>
            Der Nutzer ist verpflichtet, einen unbefugten Zugriff oder den
            Verdacht eines Missbrauchs unverzüglich seinem Unternehmen oder
            Logami zu melden.
          </p>

          <h2>4. Zulässige Nutzung</h2>
          <p>
            Logami darf ausschließlich für geschäftliche Zwecke im Rahmen der
            vorgesehenen Funktionen genutzt werden.
          </p>
          <p>Der Nutzer verpflichtet sich insbesondere,</p>
          <ul>
            <li>wahrheitsgemäße Angaben zu machen,</li>
            <li>Auftragsdaten sorgfältig zu erfassen,</li>
            <li>Zugangsdaten zu schützen,</li>
            <li>die Rechte Dritter zu respektieren,</li>
            <li>geltende Gesetze einzuhalten.</li>
          </ul>

          <h2>5. Erfasste Inhalte</h2>
          <p>
            Im Rahmen der Nutzung können insbesondere folgende Daten verarbeitet
            werden:
          </p>
          <ul>
            <li>Kundeninformationen</li>
            <li>Ansprechpartner</li>
            <li>Adressen</li>
            <li>Auftragsdaten</li>
            <li>Arbeitszeiten</li>
            <li>GPS-Standorte</li>
            <li>Fotos</li>
            <li>Notizen</li>
            <li>Unterschriften</li>
          </ul>
          <p>
            Der Nutzer darf nur Daten erfassen, die für die Durchführung seiner
            beruflichen Aufgaben erforderlich sind.
          </p>

          <h2>6. Fotos und Dokumentationen</h2>
          <p>
            Der Nutzer ist dafür verantwortlich, Fotos, Notizen und sonstige
            Dokumentationen ausschließlich im Rahmen seiner beruflichen Tätigkeit
            zu erstellen.
          </p>
          <p>
            Es dürfen keine rechtswidrigen, beleidigenden oder offensichtlich
            sachfremden Inhalte gespeichert werden.
          </p>

          <h2>7. Standortdaten</h2>
          <p>
            Sofern Standortfunktionen genutzt werden, können GPS-Daten
            verarbeitet werden.
          </p>
          <p>
            Die Nutzung erfolgt ausschließlich zur Unterstützung betrieblicher
            Prozesse wie Einsatzplanung, Dokumentation oder Arbeitszeiterfassung.
          </p>
          <p>
            Die konkrete datenschutzrechtliche Verantwortlichkeit liegt beim
            jeweiligen Unternehmen.
          </p>

          <h2>8. Verbotene Nutzung</h2>
          <p>Insbesondere untersagt sind:</p>
          <ul>
            <li>Weitergabe von Zugangsdaten,</li>
            <li>Umgehung von Sicherheitsmechanismen,</li>
            <li>Nutzung fremder Benutzerkonten,</li>
            <li>Speicherung rechtswidriger Inhalte,</li>
            <li>Verbreitung von Schadsoftware,</li>
            <li>missbräuchliche Nutzung der Plattform,</li>
            <li>Nutzung außerhalb des beruflichen Zwecks.</li>
          </ul>

          <h2>9. Datenschutz</h2>
          <p>
            Personenbezogene Daten werden gemäß den Datenschutzhinweisen von
            Logami verarbeitet.
          </p>
          <p>
            Zusätzlich können datenschutzrechtliche Hinweise des jeweiligen
            Unternehmens gelten.
          </p>
          <p>
            Fragen zur Verarbeitung von Mitarbeiter-, Kunden- oder Auftragsdaten
            sind grundsätzlich an das jeweilige Unternehmen zu richten.
          </p>

          <h2>10. Beendigung der Nutzung</h2>
          <p>
            Das Unternehmen kann den Zugang eines Nutzers jederzeit sperren oder
            entfernen.
          </p>
          <p>
            Mit Beendigung des Benutzerkontos endet das Recht zur Nutzung von
            Logami.
          </p>

          <h2>11. Änderungen dieser Nutzungsbedingungen</h2>
          <p>
            Logami kann diese Nutzungsbedingungen mit Wirkung für die Zukunft
            anpassen, soweit dies aus technischen, rechtlichen oder
            organisatorischen Gründen erforderlich ist.
          </p>
          <p>Über wesentliche Änderungen werden Nutzer rechtzeitig informiert.</p>

          <h2>12. Kontakt</h2>
          <p>
            Fragen zur Nutzung von Logami können an folgende Kontaktadresse
            gerichtet werden:
          </p>
          <address>
            Lukas Ottweiler
            <br />
            Logami
            <br />
            E-Mail:{" "}
            <a href="mailto:kontakt@logami.de">kontakt@logami.de</a>
          </address>

          <h2>13. Schlussbestimmungen</h2>
          <p>
            Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam
            sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen
            unberührt.
          </p>
        </PublicDocument>
      </AppPublicPage>
    </AppPublicLayout>
  );
}

export default Nutzungsbedingungen;
